const getApiBaseUrl = () => {
  const { hostname, port, protocol } = window.location;

  // Local development
  if (hostname === "localhost") {
    return "http://192.168.1.109:8000";
    // return "http://139.5.190.205:8999";
  }

  // Local network
  if (hostname === "192.168.1.109") {
    return "http://192.168.1.109:8000";
  }

  // Staging (FIXED)
  if (hostname === "139.5.190.205" && port === "8999") {
    return "http://139.5.190.205:8999";
  }

  // Public backend
  if (hostname === "122.176.232.35" && port === "8080") {
    return "http://122.176.232.35:8080";
  }
  if (hostname === "139.5.190.205" && port === "8999") {
    return "http://139.5.190.205:8999";
  }

  // Production
  if (hostname === "hhc.hospitalguru.in") {
    return `${protocol}//${hostname}`;
  }

  if (hostname === "test.hospitalguru.in") {
    return "https://test.hospitalguru.in:84";
  }

  return "https://hhc.hospitalguru.in";
};

export const API_URL = getApiBaseUrl();
